<div class="container-fluid">

    <div (mouseenter)="this.dotComService.DisplaySubMenu('')">
        <div class="row mt-5" style="margin:auto; width:70%; max-width:1200px">
            <div class="col-lg-6">
                <div class="row mt-3 blackText DIN2014Bold" style="font-size:28px;">
                    {{this.custNmbr}}
                </div>
                <div class="row blackText DIN2014Regular" style="font-size:20px;">
                    {{this.custName}}
                </div>
                <div class="row blackText DIN2014Regular" style="font-size:20px;">
                    {{this.custAddress}}
                </div>
            </div>
            <div class="col-lg-6">
                <div class="container">
                    <div class="row mt-3 mb-3 blackText DIN2014Regular">
                        <h4 class="col-lg-6 text-end mt-2 DIN2014Regular" style="font-size:20px;">Delivery Date:*</h4>
                        <input class="col-lg" type="date" id="deliveryDate" (change)="UpdateNotesPODelDate($event)"
                            [(ngModel)]="this.deliveryDate"
                            style="width:200px; height:40px; margin-left:20px; margin-bottom: 0px;">
                    </div>
                    <div class="row">
                        <h4 class="col-lg-6 text-end mt-2 DIN2014Regular" style="font-size:20px;">Delivery Message:</h4>
                        <select class="col-lg DIN2014Regular" style="width:200px; height:40px; margin-left:20px;"
                            [(ngModel)]="this.deliveryMessage" (change)="UpdateNotesPODelDate($event)">
                            <option value="On or Before">On or Before</option>
                            <option value="Not Before">Not Before</option>
                            <option value="This Date Only">This Date Only</option>
                            <option value="This Week">This Week</option>
                            <option value="Week Of">Week Of</option>
                        </select>
                    </div>
                    <div class="row mt-3 mb-3 blackText DIN2014Regular">
                        <h4 class="col-lg-6 text-end mt-2 DIN2014Regular" style="font-size:20px;">Purchase Order:</h4>
                        <input class="col-lg" type="text" [(ngModel)]="this.po" (change)="UpdateNotesPODelDate($event)"
                            style="width:200px; height:40px; margin-left:20px; margin-bottom: 0px;">
                    </div>
                    <div class="row mt-3 mb-3 blackText DIN2014Regular">
                        <h4 class="col-lg-6 text-end mt-2 DIN2014Regular" style="font-size:20px;">Notes:</h4>
                        <input class="col-lg" type="text" [(ngModel)]="this.notes"
                            (change)="UpdateNotesPODelDate($event)"
                            style="width:200px; height:40px; margin-left:20px; margin-bottom: 0px;">
                    </div>
                </div>
            </div>

        </div>

        <div class="container mt-5" style="margin:auto; width:70%; max-width:1200px">
            <div class="row" style="border:solid 1px grey" *ngIf="!(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                <div class="col-lg-7 mt-2 blackText DIN2014Regular">
                    <h4 style="font-size:19px">Product</h4>
                </div>
                <div class="col-lg-1 mt-2 blackText DIN2014Regular">
                    <h4 style="font-size:19px">Price</h4>
                </div>
                <div class="col-lg-1 mt-2 blackText DIN2014Regular">
                    <h4 style="font-size:19px">Qty</h4>
                </div>
                <div class="col-lg-2 mt-2 blackText DIN2014Regular">
                    <h4 style="font-size:19px">Total</h4>
                </div>
            </div>
            <div class="row pt-1 pb-1" style="border:solid 1px grey" *ngFor="let item of this.cartArray">
                <div class="col-lg-2">
                    <img style="height:120px;width:120px;" src={{item.ImageURL}}
                        onerror="this.onerror=null; src='https://harrellscomtest.blob.core.windows.net/harrellscomtest/assets/images/ProductPhotos/profertilizer_default.jpg'"
                        alt="fertilizer image">
                </div>
                <div class="col-lg-5 justify-content-center align-self-center blackText DIN2014Regular"
                    style="font-size:16px">{{item.webName}}</div>
                <div class="col-lg-1 justify-content-center align-self-center blackText DIN2014Regular"
                    style="font-size:16px">{{item.priceEach}}</div>
                <div class="col-lg-1 justify-content-center align-self-center blackText DIN2014Regular"
                    style="font-size:16px"><input style="width:90%" type="text" value="{{item.qty}}"
                        (change)="UpdateItemQty($event, item)" (keypress)="dotComService.mustBeDigitNoPeriods($event)" 
                        (keyup.enter)="UpdateItemQty($event, item)"
                        >
                </div>
                <div class="col-lg-1 justify-content-center align-self-center blackText DIN2014Regular"
                    style="font-size:16px">{{item.TotalPrice}}</div>
                    <div *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                    class="col-lg-1 justify-content-center align-self-center blackText DIN2014Regular blueText"
                    style="font-size:24px" (click)="DeleteItem(item)">remove</div>

                <div *ngIf="!(this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                class="col-lg-1 justify-content-center align-self-center blackText DIN2014Regular"
                    style="cursor:pointer;font-size:24px" (click)="DeleteItem(item)">X</div>
            </div>

        </div>

        <div class="container mt-0 mb-5" style="margin:auto; width:70%; max-width:1200px">
            <div class="row" style="border:solid 1px grey">
                <div class="col-lg-11 mt-2 blackText DIN2014Regular">
                    <h4 style="font-size:19px">Total</h4>
                </div>
                <div class="col-lg-1 mt-2 blackText DIN2014Regular">
                    <h4 style="font-size:19px">{{this.grandTotal.toFixed(2)}}</h4>
                </div>
            </div>
        </div>
        <div class="container mt-0 mb-5" style="margin:auto; width:70%; max-width:1200px">
            <div class="row justify-content-end">
                <button class="DIN2014Bold blueBackground whiteText" (click)="StartOver()"
                    style="margin-left:10px; width:260px; border:none; font-size:20px; line-height: 2; text-decoration: none !important">START OVER</button>
                <button class="DIN2014Bold blueBackground whiteText bottomButtons" (click)="ContinueShopping()">CONTINUE SHOPPING</button>
                <button class="DIN2014Bold blueBackground whiteText bottomButtons" (click)="SubmitOrder()"
                [disabled]="this.disableSubmit"
                [ngClass]="this.disableSubmit ? 'greyDisabled': 'blueBackground'">SUBMIT ORDER</button>
            </div>
        </div>


    </div>
</div>